import { render, staticRenderFns } from "./ClientAdmin.vue?vue&type=template&id=7eb6c5e0&scoped=true&"
import script from "./ClientAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ClientAdmin.vue?vue&type=style&index=0&id=7eb6c5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb6c5e0",
  null
  
)

export default component.exports